import del from './methodDelete';
import get from './methodGet';
import put from './methodPut';
import post from './methodPost';

export default { ...del, ...get, ...put, ...post };
